(() => {

    /**
     * @ngdoc service
     * @name services.$focus
     *
     * @description
     * Sends a `focus` event to a directive which will focus its element
     */
    angular.module('services')
        .factory('$focus', $timeout => (scope, name, timeout) => {

            $timeout(() => {

                scope.$broadcast('focus', name);

            }, timeout || 250);

        });

})();



// WEBPACK FOOTER //
// ./scripts/common/services/util/Focus.js